import React from 'react';
import { IconSvgProps } from '@models/common';

const Cycle: React.FC<IconSvgProps> = (props) => {
  const { size = 24, strokeWidth = 2, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M4.09 7.414A9.143 9.143 0 1 1 2.856 12'
      />
      <path
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={strokeWidth}
        d='M8.571 7.428H4v-4.57'
      />
    </svg>
  );
};

export default Cycle;
